import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeUrl',
    standalone: false
})
export class SafeUrlPipe implements PipeTransform {
    private readonly sanitizer = inject(DomSanitizer);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    transform(value: any, ...args: any[]): any {
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    }
}
